import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=24018573&scoped=true"
import script from "./side-menu.vue?vue&type=script&lang=js"
export * from "./side-menu.vue?vue&type=script&lang=js"
import style0 from "./side-menu.vue?vue&type=style&index=0&id=24018573&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24018573",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24018573')) {
      api.createRecord('24018573', component.options)
    } else {
      api.reload('24018573', component.options)
    }
    module.hot.accept("./side-menu.vue?vue&type=template&id=24018573&scoped=true", function () {
      api.rerender('24018573', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/public/main/components/side-menu/side-menu.vue"
export default component.exports